/**
 * @description Payment method type, e.g. card, bank, paypal.
 */
export enum PaymentMethodType {
  Any = 'Any',
  Cash = 'Cash',
  Check = 'Check',
  BankAccount = 'BankAccount',
  CreditCard = 'CreditCard',
  PayPal = 'PayPal',
  EWallet = 'EWallet',
  DebitCard = 'DebitCard',
  PayNearMe = 'PayNearMe',
  DirectBank = 'DirectBank',
  StagedRia = 'StagedRia',
  SencillitoOnline = 'SencillitoOnline',
  PayID = 'PayID',
  RiaWallet = 'RiaWallet',
  Giropay = 'Giropay',
  StagedOnline = "StagedOnline",
  ApplePay = "ApplePay",
  GooglePay = "GooglePay",
  ApplePayCredit = "ApplePayCredit",
  GooglePayCredit = "GooglePayCredit",
  OpenBanking = "OpenBanking"
}

export enum EarlyReleasePaymentMethod {
  Bank = 'Bank Account',
  DebitCard = 'Debit Card'
}

export enum PaymentMethodTypeID {
  Any = 0,
  Cash = 10,
  Check = 20,
  BankAccount = 30,
  CreditCard = 40,
  PinDebitCard = 50,
  PayPal = 60,
  EWallet = 70,
  DebitCard = 80,
  StagedTransactionEPay = 90,
  PayNearMe = 91,
  StagedRia = 92,
  DirectBank = 120,
  RiaWallet = 140,
  PayID = 130,
  Giropay = 160,
  SencillitoOnline = 1092,
  StagedOnline = 230,
  OpenBanking = 115
}

export enum DirectBankBrand{
  None = '',
  PoliPay =' PoliPay',
  Klarna = 'Klarna',
  FPX = 'FPX',
  IDeal = 'iDEAL',
  Bancontact = 'Bancontact',
  Fintoc = 'Fintoc',
  Blik = 'Blik',
  AdyenBancontact = 'bcmc',
  MBWay = 'mbway',
  Swish = 'Swish',
}

export enum StagedRiaBrand {
  Kroger = 'Kroger'
}

export enum PayNearMeBrand {
  SevenEleven = 'SevenEleven'
}

export enum PayListType {
  Payment = 'payment',
  Delivery = 'delivery'
}

export enum PaymentVerificationType {
  Plaid = 'Plaid'
}

export enum PaymentMethodCardType {
  CreditCard = 'credit',
  DebitCard = 'debit'
}


// WEBPACK FOOTER //
// ./src/model/types/payment-method-type.ts